import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { isNullOrEmpty, showMessageToastCustom, translate } from '../../../../utils/util';
import { Select, Breadcrumbs, Button, SelectResource } from '../../../../components/UI/ComponentsUI';
import { validateInputsRequired, onValueChange } from '../../../../utils/handleChangeHooks';
import { ENUMS, VISIONS } from '../../../../utils/constants';
import { getVision } from '../../../../services/auth';
import ChangeLocationService from '../../../../services/ChangeLocationService';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

const ChangeLocationUpload = (props) => {
    var vision = getVision();
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.shee;charset=UTF-8';
    const fileExtension = '.xlsx';
    const template = [{ Cim: "", Destino: "", Quebra: "" }];
    const [selectedFile, setSelectedFile] = useState();
    const [messages, setMessages] = useState([]);
    const [change, setChange] = useState({
        print: (vision === VISIONS.Faasa || vision === VISIONS.FaasaCKD) ? ENUMS.ePrintTypes.NotPrint.value : props.printSelect,
        resourceId: props.user.resource || ""
    });

    const onChange = (event) => {
        onValueChange(event, change, setChange);
    };

    const setResource = () => {
        if (change.print === ENUMS.ePrintTypes.Click.value && !isNullOrEmpty(props.user?.resourceObj?.clickResourceName)) {
            return props.user?.resourceObj?.clickResourceName;
        }

        return props.user?.resourceObj?.name;
    }

    const validateResource = () => {
        if (!props.user?.resourceObj) {
            showMessageToastCustom(translate('warning', 'general'), translate('select-resource', 'validations'), 3000, 'mdi mdi-alert-circle-outline red-text');
            return false;
        }

        return true;
    }

    const onConfirm = () => {
        if (validateInputsRequired("formLocation") && validateResource()) {
            const data = {
                ...change,
                printer: props.user?.printer,
                resource: setResource()
            }

            props.uploadSendLocation(data, selectedFile, (response) => {
                setMessages(response || []);
                clearFileInput();
            })
        }
    }

    const clearFileInput = () => {
        document.getElementById("fileLocation").value = "";
        setSelectedFile();
    }

    const exportExcel = () => {
        const ws = XLSX.utils.json_to_sheet(template);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, 'Template' + fileExtension);

    }

    return (
        <div>
            <Breadcrumbs id="changeLocation" title={{ icon: "mdi mdi-clipboard-check-outline", label: "Troca de locação" }} />
            <div className="title" style={{ float: 'right', margin: '10px' }}>
                <i className="mdi mdi-24px mdi-arrow-down-circle" style={{ cursor: 'pointer' }} onClick={() => exportExcel()}></i>
            </div>

            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className='container'>
                    <div className='card'>
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div id="formLocation" className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding  col s12">
                                    <Select
                                        required
                                        id="print"
                                        name="print"
                                        display="name"
                                        label={translate('print-type', 'physical-confirmation')}
                                        placeHolder={translate('choose-one-option', 'general')}
                                        data={[
                                            { id: ENUMS.ePrintTypes.Logistics.value, text: translate(ENUMS.ePrintTypes.Logistics.text, 'physical-confirmation') },
                                            { id: ENUMS.ePrintTypes.Click.value, text: translate(ENUMS.ePrintTypes.Click.text, 'physical-confirmation') },
                                            { id: ENUMS.ePrintTypes.NotPrint.value, text: translate(ENUMS.ePrintTypes.NotPrint.text, 'physical-confirmation') },
                                        ]}
                                        change={(e) => {
                                            props.setPrintSelect(e.target.value);
                                            onChange(e);
                                        }}
                                        defaultValue={change.print}
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <SelectResource
                                        required
                                        id="resourceId"
                                        name="resourceId"
                                        loadConfigLaser={vision === VISIONS.Jeep}
                                        value={change.resourceId}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <input
                                        id="fileLocation"
                                        required
                                        type="file"
                                        onClick={clearFileInput}
                                        onChange={(event) => setSelectedFile(event.target.files[0])}
                                        accept=".txt, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ marginTop: '20px' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                            {messages.length > 0 &&
                                <div style={{ display: 'flex', flexDirection: 'column', padding: '15px 0px' }}>
                                    {messages.map((item) => (
                                        <span key={item.entrance} className={item.success ? "success-color" : "fourth-text-color"}>
                                            {item.entrance} - {item.location} - {item.success ? "OK" : item.message}
                                        </span>
                                    ))}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        resources: state.logisticsResourceReducer.list,
        user: state.userReducer.user,
        config: state.configReducer.config,
        printSelect: state.physicalConfirmationReducer.printSelect
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        uploadSendLocation: (file, selectedFile, callback) => {
            dispatch(ChangeLocationService.uploadFile(file, selectedFile, callback));
        },
        setPrintSelect: (printSelect) => {
            dispatch(ChangeLocationService.setPrintSelect(printSelect));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ChangeLocationUpload));
